import React, { createContext, useState } from "react";

export const FormValidateContext = createContext(null);

const FormValidateValue = () => {
    const [fields, setFields] = useState([]);
    const [errors, setErrors] = useState([]);
    const [globalError, setGlobalError] = useState(null);

    const registerField = (field) => {
        setFields((_fields) => [..._fields, field]);
    };

    const unregisterField = (field) => {
        setFields((_fields) => _fields.filter((_field) => _field.id !== field.id));
    };

    const getFieldError = (_id) => errors.find((err) => err.id === _id);

    const validateForm = () => {
        const validationErrors = [];
        let firstInvalidField = null;

        // eslint-disable-next-line no-unsafe-optional-chaining
        fields?.sort((a, b) => a?.ref?.current.offsetTop - b?.ref?.current.offsetTop).forEach((_field) => {
            const fieldValidation = _field.validate();
            if (fieldValidation !== true) {
                validationErrors.push({ id: _field.id, message: fieldValidation });

                if (!firstInvalidField) {
                    firstInvalidField = _field.ref;
                }
            }
        });

        setErrors(validationErrors);
        if (firstInvalidField && firstInvalidField.current) {
            firstInvalidField.current.scrollIntoView({ behavior: "smooth", block: "center" });
            const input = firstInvalidField.current.querySelector('input, textarea, select, [contenteditable="true"]');
            if (input) {
                input.focus();
            }

        }

        if (validationErrors.length > 0) {
            const _globalError = validationErrors.find((err) => err.message.includes(":") && err.message.split(":")[1]?.trim());
            if (_globalError) {
                setGlobalError(_globalError.message.split(":")[1].trim());
            } else {
                setGlobalError(null);
            }
        } else {
            setGlobalError(null);
        }

        return validationErrors.length === 0;
    };

    const clearFieldError = (_id) => {
        setErrors((_errors) => _errors.filter((err) => err.id !== _id));
    };

    return {
        registerField, unregisterField, validateForm, errors, getFieldError, clearFieldError, globalError, setGlobalError,
    };
};

const FormValidateProvider = ({ children }) => {
    const value = FormValidateValue();

    return (
        <FormValidateContext.Provider value={value}>
            {children}
        </FormValidateContext.Provider>
    );
};

export default FormValidateProvider;
